import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataViewModule } from 'primeng/dataview';
import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-user-grid-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    DataViewModule,
    ButtonModule,
    SkeletonModule
  ],
  templateUrl: './user-grid-sidebar.component.html',
  styleUrls: ['./user-grid-sidebar.component.scss'],
})
export class UserGridSidebarComponent {
  /** estado de loading da grid */
  @Input() isLoading = false;

  /** itens reais da grid */
  @Input() items: any[] = [];

  /** skeletons da grid */
  @Input() skeletonItems: any[] = [];

  /** eventos para o pai */
  @Output() itemClick = new EventEmitter<any>();

  onItemClick(item: any) {
    this.itemClick.emit(item);
  }
}
